/** Columns shared by every payroll report. */
export const BASE_REPORT_FIELDS = [
  "agency",
  "surname",
  "Firstname",
  "Middlename",
  "employmentType",
  "position",
];

export const BASE_REPORT_INCLUDES = ["employmentType", "position"];

export const GSIS_LOAN_FIELDS = [
  {
    key: "dueToGsisGsisOptionalInsurance",
    label: "GSIS Optional Insurance",
  },
  { key: "dueToGsisGsisPolicyLoan", label: "GSIS Policy Loan" },
  { key: "dueToGsisGsisEmergencyLoan", label: "GSIS Emergency Loan" },
  {
    key: "dueToGsisGsisOptionalPolicy",
    label: "GSIS Optional Policy",
  },
  {
    key: "dueToGsisGsisConsolidatedLoan",
    label: "GSIS Consolidated Loan",
  },
  {
    key: "dueToGsisGsisEducationalAssistanceLoan",
    label: "GSIS Educational Assistance Loan",
  },
  { key: "dueToGsisGsisComputerLoan", label: "GSIS Computer Loan" },
  {
    key: "dueToGsisGsisMultipurposeLoan",
    label: "GSIS Multi-Purpose Loan",
  },
  { key: "dueToGsisGfal", label: "GSIS GFAL" },
  { key: "dueToGsisGsisSalaryLoan", label: "GSIS Salary Loan" },
  {
    key: "dueToGsisGsisSummerOneTimeSalaryLoan",
    label: "GSIS Summer One-Time Salary Loan",
  },
  {
    key: "dueToGsisGsisEmergencyLoanAssistance",
    label: "GSIS Emergency Loan Assistance",
  },
  {
    key: "dueToGsisGsisMembersCashAdvance",
    label: "GSIS Member's Cash Advance",
  },
];

export const HDMF_LOAN_FIELDS = [
  {
    key: "dueToPagIbigPagibigMpl",
    label: "Due to PAG-IBIG (Pagibig MPL)",
  },
  {
    key: "dueToPagIbigPagibigCalamityLoan",
    label: "Due to PAG-IBIG (Pagibig Calamity Loan)",
  },
  {
    key: "dueToPagIbigPagibigIi",
    label: "Due to PAG-IBIG (Pagibig II)",
  },
];

export const GSIS_REMITTANCE_FIELDS = [
  "employeeShare",
  "employerShare",
  "totalGsis",
];

/** Same shape as GSIS premium remittance; contribution key is pagibig. */
export const HDMF_PREMIUM_REMITTANCE_FIELDS = [
  "employeeContribution",
  "employerContribution",
  "Total",
];

export const PHILHEALTH_PREMIUM_REMITTANCE_FIELDS = [
  "monthlyRate",
  "employeeShare",
  "employerShare",
  "totalPremium",
];

export const PHIC_PREMIUM_REMITTANCE_FIELDS = [
  "monthlyRate",
  "employeePremium",
  "employerPremium",
  "totalPremium",
];

export const HDMF_MP2_REMITTANCE_FIELDS = ["mp2Account", "contribution"];

export const HDMF_HOUSING_REMITTANCE_FIELDS = [
  "housingLoanAccount",
  "monthlyAmortization",
  "deducted",
];

export const GSIS_LOAN_REPORT_FIELDS = [
  ...GSIS_LOAN_FIELDS.map(({ key }) => key),
  "totalGsisLoan",
];

export const HDMF_LOAN_REPORT_FIELDS = [
  ...HDMF_LOAN_FIELDS.map(({ key }) => key),
  "totalHdmfLoan",
];

/** All individual loan deduction columns for Loan Monitoring. */
export const LOAN_MONITORING_FIELDS = [
  ...GSIS_LOAN_FIELDS.map(({ key }) => key),
  ...HDMF_LOAN_FIELDS.map(({ key }) => key),
  "totalLoanDeduction",
];

export const DERIVED_FIELDS = {
  monthlyRate: {
    label: "Monthly Rate",
    type: "String",
    keys: ["nonRegPosition", "salaryCode"],
    include: ["nonRegPosition"],
  },
  overPayment: {
    label: "Over Payment",
    type: "String",
    keys: [],
    include: [],
  },
  longevityRate: {
    label: "Longevity Rate",
    type: "String",
    keys: ["lengthOfService"],
    include: [],
  },
  longevityPay: {
    label: "Longevity Pay",
    type: "String",
    // Needs monthly rate sources + lengthOfService to compute.
    keys: ["lengthOfService", "nonRegPosition", "salaryCode"],
    include: ["nonRegPosition"],
  },
  totalLoanDeduction: {
    label: "Total Loan Deduction",
    type: "String",
    keys: [],
    include: [],
  },
  tax: {
    label: "Total Tax",
    type: "String",
    keys: [],
    include: [],
  },
  totalCoopDeduction: {
    label: "Total COOP Deduction",
    type: "String",
    keys: [],
    include: [],
  },
  peraAda: {
    label: "PERA/ADA",
    type: "String",
    keys: [],
    include: [],
  },
  overpaymentBasic: {
    label: "OVERPAYMENT (BASIC)",
    type: "String",
    keys: [],
    include: [],
  },
  overpaymentPeraAda: {
    label: "OVERPAYMENT (PERA ADA)",
    type: "String",
    keys: [],
    include: [],
  },
  earnedBasic: {
    label: "EARNED (BASIC)",
    type: "String",
    keys: [],
    include: [],
  },
  earnedPeraAda: {
    label: "EARNED (PERA ADA)",
    type: "String",
    keys: [],
    include: [],
  },
  mandatoryDeductions: {
    label: "MANDATORY DEDUCTIONS",
    type: "String",
    keys: [],
    include: [],
  },
  loansOtherDeductions: {
    label: "LOANS AND OTHER DEDUCTIONS",
    type: "String",
    keys: [],
    include: [],
  },
  netAmount: {
    label: "NET PAY",
    type: "String",
    keys: [],
    include: [],
  },
  employeeShare: {
    label: "Employee Share",
    type: "String",
    keys: [],
    include: [],
  },
  employerShare: {
    label: "Employer Share",
    type: "String",
    keys: [],
    include: [],
  },
  totalGsis: {
    label: "Total GSIS",
    type: "String",
    keys: [],
    include: [],
  },
  ...Object.fromEntries(
    GSIS_LOAN_FIELDS.map(({ key, label }) => [
      key,
      { label, type: "String", keys: [], include: [] },
    ]),
  ),
  totalGsisLoan: {
    label: "Total",
    type: "String",
    keys: [],
    include: [],
  },
  ...Object.fromEntries(
    HDMF_LOAN_FIELDS.map(({ key, label }) => [
      key,
      { label, type: "String", keys: [], include: [] },
    ]),
  ),
  totalHdmfLoan: {
    label: "Total",
    type: "String",
    keys: [],
    include: [],
  },
  premiums: {
    label: "Premiums",
    type: "String",
    keys: [],
    include: [],
  },
  loans: {
    label: "Loans",
    type: "String",
    keys: [],
    include: [],
  },
  totalPayment: {
    label: "Total Payment",
    type: "String",
    keys: [],
    include: [],
  },
  employeeContribution: {
    label: "Employee Contribution",
    type: "String",
    keys: [],
    include: [],
  },
  employerContribution: {
    label: "Employer Contribution",
    type: "String",
    keys: [],
    include: [],
  },
  Total: {
    label: "Total",
    type: "String",
    keys: [],
    include: [],
  },
  totalPremium: {
    label: "Total Premium",
    type: "String",
    keys: [],
    include: [],
  },
  employeePremium: {
    label: "Employee Premium",
    type: "String",
    keys: [],
    include: [],
  },
  employerPremium: {
    label: "Employer Premium",
    type: "String",
    keys: [],
    include: [],
  },
  mp2Account: {
    label: "MP2 Account",
    type: "String",
    keys: [],
    include: [],
  },
  contribution: {
    label: "Contribution",
    type: "String",
    keys: [],
    include: [],
  },
  housingLoanAccount: {
    label: "Housing Loan Account",
    type: "String",
    keys: [],
    include: [],
  },
  monthlyAmortization: {
    label: "Monthly Amortization",
    type: "String",
    keys: [],
    include: [],
  },
  deducted: {
    label: "Deducted",
    type: "String",
    keys: [],
    include: [],
  },
};

/** Only these payroll.deduction keys count toward Total Loan Deduction. */
export const LOAN_DEDUCTION_KEYS = [
  "dueToGsisGsisOptionalInsurance",
  "dueToGsisGsisPolicyLoan",
  "dueToGsisGsisEmergencyLoan",
  "dueToGsisGsisOptionalPolicy",
  "dueToGsisGsisConsolidatedLoan",
  "dueToGsisGsisEducationalAssistanceLoan",
  "dueToGsisGsisComputerLoan",
  "dueToGsisGsisMultipurposeLoan",
  "dueToGsisGfal",
  "dueToGsisGsisSalaryLoan",
  "dueToGsisGsisSummerOneTimeSalaryLoan",
  "dueToGsisGsisEmergencyLoanAssistance",
  "dueToGsisGsisMembersCashAdvance",
  "dueToPagIbigPagibigMpl",
  "dueToPagIbigPagibigCalamityLoan",
  "dueToPagIbigPagibigIi",
];

/** Only this payroll.deduction key counts toward Total COOP Deduction. */
export const COOP_DEDUCTION_KEYS = ["dueToCoop"];

/** Only this contribution key counts toward GSIS Employee Share. */
export const GSIS_EMPLOYEE_SHARE_KEYS = ["gsisLR"];

/** Only this contribution key counts toward HDMF Personal Share. */
export const HDMF_EMPLOYEE_SHARE_KEYS = ["pagibig"];

/** Only this contribution key counts toward PhilHealth Employee Share. */
export const PHIC_EMPLOYEE_SHARE_KEYS = ["phic"];

export const GENERAL_PAYROLL_FIELDS = [
  "peraAda",
  "overpaymentBasic",
  "overpaymentPeraAda",
  "earnedBasic",
  "earnedPeraAda",
  "tax",
  "mandatoryDeductions",
  "loansOtherDeductions",
  "netAmount",
];

export const GSIS_PAYMENT_SUMMARY_FIELDS = [
  "premiums",
  "loans",
  "totalPayment",
];

/** Same columns as GSIS payment summary; amounts use HDMF premium + HDMF loans only. */
export const HDMF_PAYMENT_SUMMARY_FIELDS = [...GSIS_PAYMENT_SUMMARY_FIELDS];

export const PAYROLL_REPORT_CATEGORIES = [
  {
    key: "payroll",
    label: "Payroll",
    color: "#0d9488",
    reports: [
      {
        key: "overpayments",
        label: "Overpayments",
        fields: ["monthlyRate", "overPayment"],
      },
      {
        key: "longevity_pay",
        label: "Employees Entitled to Longetivity Pay",
        fields: [
          "hired",
          "lengthOfService",
          "monthlyRate",
          "longevityRate",
          "longevityPay",
        ],
      },
      {
        key: "loan_deduction_summary",
        label: "Summary of Loan Deduction",
        fields: ["totalLoanDeduction"],
      },
      {
        key: "general_payroll",
        label: "General Payroll",
        fields: ["monthlyRate", ...GENERAL_PAYROLL_FIELDS],
        fieldLabels: {
          monthlyRate: "MONTHLY RATE",
          tax: "TAX",
        },
      },
      {
        key: "tax_remittance",
        label: "Tax Remittance",
        fields: ["tax"],
      },
      {
        key: "cooperative_deduction",
        label: "Cooperative Deduction per Employee",
        fields: ["totalCoopDeduction"],
      },
      {
        key: "loan_monitoring",
        label: "Loan Monitoring",
        fields: [...LOAN_MONITORING_FIELDS],
      },
    ],
  },
  {
    key: "gsis",
    label: "GSIS",
    color: "#2563eb",
    reports: [
      {
        key: "gsis_remittance",
        label: "GSIS Remmittance",
        fields: [...GSIS_REMITTANCE_FIELDS],
      },
      {
        key: "gsis_loan_remittance",
        label: "GSIS Loan Remmittance",
        fields: [...GSIS_LOAN_REPORT_FIELDS],
      },
      {
        key: "gsis_premium_remittance",
        label: "GSIS Premium Remmittance",
        fields: [...GSIS_REMITTANCE_FIELDS],
        fieldLabels: {
          employeeShare: "Personal Share",
          employerShare: "Government Share",
          totalGsis: "Total Premium",
        },
      },
      {
        key: "gsis_payment_summary",
        label: "GSIS Summary of Payment",
        fields: [...GSIS_PAYMENT_SUMMARY_FIELDS],
      },
      { key: "gsis_real_estate_loan", label: "GSIS Real State Loan" },
    ],
  },
  {
    key: "hdmf",
    label: "HDMF / Pag-IBIG",
    color: "#d97706",
    reports: [
      {
        key: "hdmf_premium_remittance",
        label: "HDMF Premium Remittance",
        fields: [...HDMF_PREMIUM_REMITTANCE_FIELDS],
      },
      {
        key: "hdmf_loan_remittance",
        label: "HDMF Loan Remittance",
        fields: [...HDMF_LOAN_REPORT_FIELDS],
      },
      {
        key: "hdmf_mp2_remittance",
        label: "HDMF MP2 Remittance",
        fields: [...HDMF_MP2_REMITTANCE_FIELDS],
      },
      {
        key: "hdmf_housing_remittance",
        label: "HDMF Housing Remittance",
        fields: [...HDMF_HOUSING_REMITTANCE_FIELDS],
      },
      {
        key: "hdmf_payment_summary",
        label: "HDMF Summary of Payment",
        fields: [...HDMF_PAYMENT_SUMMARY_FIELDS],
      },
    ],
  },
  {
    key: "philhealth",
    label: "PhilHealth / PHIC",
    color: "#059669",
    reports: [
      {
        key: "philhealth_premium_remittance",
        label: "Philhealth Premium Remittance",
        fields: [...PHILHEALTH_PREMIUM_REMITTANCE_FIELDS],
        fieldLabels: {
          monthlyRate: "Monthly Basic Salary",
          totalPremium: "Total Premium",
        },
      },
      {
        key: "phic_premium_remittance",
        label: "PHIC Premium Remittance",
        fields: [...PHIC_PREMIUM_REMITTANCE_FIELDS],
        fieldLabels: {
          monthlyRate: "Compenstation",
        },
      },
    ],
  },
];

export function getPayrollReportByKey(reportKey) {
  for (const category of PAYROLL_REPORT_CATEGORIES) {
    const report = category.reports.find(({ key }) => key === reportKey);
    if (report) {
      return {
        ...report,
        category: category.key,
        categoryLabel: category.label,
        color: category.color,
      };
    }
  }
  return null;
}

/** Columns shown for a report — base columns plus the report's own fields. */
export function getReportFields(report) {
  return [...BASE_REPORT_FIELDS, ...(report?.fields ?? [])];
}

/** Employee keys to query: plain fields as-is, derived fields via their sources. */
export function getReportQueryKeys(report) {
  const keys = new Set(BASE_REPORT_FIELDS);

  getReportFields(report).forEach((field) => {
    const derived = DERIVED_FIELDS[field];
    if (derived) {
      derived.keys.forEach((key) => keys.add(key));
      return;
    }
    keys.add(field);
  });

  return [...keys];
}

export function getReportIncludes(report) {
  const includes = new Set(BASE_REPORT_INCLUDES);

  getReportFields(report).forEach((field) => {
    DERIVED_FIELDS[field]?.include?.forEach((key) => includes.add(key));
  });

  return [...includes];
}
